import { useState } from 'react';
import ContactCanvas from './ContactCanvas';
import styles from '../styles/Contact.module.css';

const INITIAL_FORM = { name: '', email: '', message: '' };
const WEB3FORMS_ACCESS_KEY = '26f67437-e094-4900-9507-c3c33b1f3f02';

export default function Contact() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [status, setStatus] = useState('idle');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          subject: `New portfolio message from ${form.name}`,
          ...form,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus('sent');
        setForm(INITIAL_FORM);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className={`section ${styles.section}`}>
      <ContactCanvas />
      <div className={`container ${styles.inner}`}>
        <div className="section-head" data-anim>
          <span className="section-index">07</span>
          <span className="section-rule" />
          <h2 className="section-title">Contact</h2>
        </div>

        <div className={styles.grid}>
          <div>
            <h3 className={styles.heading} data-anim>
              Let&rsquo;s build
              <br />
              <span className={styles.headingAccent}>something fast.</span>
            </h3>
            <p className={styles.lead} data-anim>
              Open to WordPress builds, MERN work, and SaaS product engineering. Reply time is usually under a day.
            </p>
            <a href="mailto:ansariyaaeen361@gmail.com" className={styles.emailLink} data-anim>
              ansariyaaeen361@gmail.com
            </a>
            <a href="tel:+923141306506" className={styles.phoneLink} data-anim>
              +92 314 1306506
            </a>
            <div className={styles.socials} data-anim>
              <a
                href="https://github.com/ansariyaaeen361-arch"
                target="_blank"
                rel="noreferrer"
                className={`${styles.socialBtn} ${styles.cy}`}
              >
                GitHub <span style={{ fontSize: 13 }}>↗</span>
              </a>
              <a
                href="https://linkedin.com/in/muhammad-yaseen-716815334"
                target="_blank"
                rel="noreferrer"
                className={`${styles.socialBtn} ${styles.pu}`}
              >
                LinkedIn <span style={{ fontSize: 13 }}>↗</span>
              </a>
            </div>
          </div>

          <form className={styles.form} onSubmit={handleSubmit} data-anim>
            <label className={styles.field}>
              <span>Name</span>
              <input name="name" type="text" placeholder="Your name" value={form.name} onChange={handleChange} required />
            </label>
            <label className={styles.field}>
              <span>Email</span>
              <input
                name="email"
                type="email"
                placeholder="you@company.com"
                value={form.email}
                onChange={handleChange}
                required
              />
            </label>
            <label className={styles.field}>
              <span>Message</span>
              <textarea
                name="message"
                rows={4}
                placeholder="What are you building?"
                value={form.message}
                onChange={handleChange}
                required
              />
            </label>
            <button type="submit" className={styles.submit} disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Send Message'}
            </button>
            {status === 'sent' && (
              <span className={`${styles.note} ${styles.noteSent}`}>Thanks — I’ll reply within a day.</span>
            )}
            {status === 'error' && (
              <span className={`${styles.note} ${styles.noteError}`}>
                Something went wrong — please email me directly.
              </span>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}
